export const missingExpensesDataWarningCard = {
	message:
		"Ainda existem informações obrigatórias não preenchidas. Informe os dados nescessários para submeter o fechamento do evento.",
};
